/**
 * Optional admin API key for governance endpoints (localStorage or VITE_ADMIN_API_KEY).
 */

export const ADMIN_API_KEY_STORAGE_KEY = "identity_armour_admin_api_key";

export const ADMIN_API_KEY_CHANGED = "identity-armour:admin-api-key-changed";

function envAdminFallback(): string {
  return import.meta.env.VITE_ADMIN_API_KEY?.trim() ?? "";
}

export function getAdminApiKey(): string {
  if (typeof localStorage === "undefined") {
    return envAdminFallback();
  }
  const stored = localStorage.getItem(ADMIN_API_KEY_STORAGE_KEY);
  if (stored !== null) {
    return stored.trim();
  }
  return envAdminFallback();
}

export function setAdminApiKey(value: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(ADMIN_API_KEY_STORAGE_KEY, value.trim());
  window.dispatchEvent(new CustomEvent(ADMIN_API_KEY_CHANGED));
}

export function clearAdminApiKey(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(ADMIN_API_KEY_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(ADMIN_API_KEY_CHANGED));
}
